import { useRef, useState } from "react";
import Carousel from "react-multi-carousel";
import useFirstViewportEntry from "../hooks/useFirstViewportEntry";
import { viewportData } from "../data/constants";
import { CustomLeftArrow, CustomRightArrow } from "./CustomButtons";
import { ProductCard } from "./ProductCard";
import "react-multi-carousel/lib/styles.css";
import { useSelector } from "react-redux";
import { getLang } from "../redux/selectors";

export const MenuSection = ({ data }) => {
  const ref = useRef(null);
  const isVisible = useFirstViewportEntry(ref);
  const lang = useSelector(getLang);
  const availableProducts = data.products.filter((el) => el.show);
  const [selected, setSelected] = useState(0);

  const handleBeforeChange = (nextSlide, { currentSlide }) => {
    if (nextSlide > currentSlide) {
      setSelected((prev) => ++prev);
    } else {
      setSelected((prev) => --prev);
    }
  };

  return (
    <div
      id={`menu_${data.categoryId}`}
      className={`menu-section ${isVisible > 0 ? "visible" : ""} `}
      ref={ref}
    >
      <h3 className="section-header">{data.categoryName[lang]}</h3>
      <Carousel
        responsive={viewportData}
        beforeChange={handleBeforeChange}
        customRightArrow={<CustomRightArrow />}
        customLeftArrow={<CustomLeftArrow />}
        showThumbs={false}
      >
        {availableProducts.map(
          (el) => el.show && <ProductCard key={el.productId} product={el} />
        )}
      </Carousel>
      <div className="flex justify-center sm:hidden">
        {availableProducts.map(
          (el, idx) =>
            el.show && (
              <div
                key={el.productId}
                className={`w-3 h-3 rounded-full border-2 mt-1 mx-[1px] border-gray-400 ${
                  selected === idx ? "bg-mainRed" : ""
                }`}
              ></div>
            )
        )}
      </div>
    </div>
  );
};
